import { createStore } from 'vuex'

export default createStore({
    state: {
        keyPath:"/",
        detail:{}
    },
    mutations: {
    },
    actions: {
    },
    modules: {
    }
})

